module.exports = __webpack_public_path__ + "img/slide_title-balloon.6117ec6b.svg";